const Forbidden = () => (
  <div className="mt-8 flex flex-col items-center justify-center">
    <h1 className="text-4xl font-bold">403 Forbidden</h1>
    <p className="mt-2 text-lg">
      The page you are trying to reach is absolutely forbidden for some reason.
    </p>
  </div>
)

export default Forbidden
